import React from 'react';

const LogoSeatgeekColorSvg = (props) => (
    <svg viewBox="0 0 72 72" {...props}>
        <path
            fill="#1673e6"
            d="M12.35 14.46s9-5.91 23.65-5.91 23.65 5.91 23.65 5.91l-5.91 31.4H18.26zM12.35 52.81S21.55 57 36 57s23.65-4.2 23.65-4.2v6.7S50.29 63.46 36 63.46s-23.65-3.94-23.65-3.94zM11.83 48.48V37.31A3.28 3.28 0 0 0 8.54 34H0v5.91h5.52v8.54zM60.17 48.48V37.31A3.28 3.28 0 0 1 63.46 34H72v5.91h-5.52v8.54z"
        />
    </svg>
);

LogoSeatgeekColorSvg.displayName = 'LogoSeatgeekColorSvg';
export default LogoSeatgeekColorSvg;
